/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockGoodsListBarcodeItem
 */
export interface StockGoodsListBarcodeItem {
    /**
     * 条码主键ID
     * @type {number}
     * @memberof StockGoodsListBarcodeItem
     */
    id?: number;
    /**
     * 平台条码
     * @type {string}
     * @memberof StockGoodsListBarcodeItem
     */
    marketBarcode?: string;
    /**
     * 平台商品名称
     * @type {string}
     * @memberof StockGoodsListBarcodeItem
     */
    marketProductName?: string;
    /**
     * 平台选项名称
     * @type {string}
     * @memberof StockGoodsListBarcodeItem
     */
    marketOptionName?: string;
    /**
     * 平台选项ID
     * @type {string}
     * @memberof StockGoodsListBarcodeItem
     */
    marketOptionId?: string;
    /**
     * 第三方电商平台ID
     * @type {number}
     * @memberof StockGoodsListBarcodeItem
     */
    businessPlatformId?: number;
    /**
     * 第三方电商平台名称
     * @type {string}
     * @memberof StockGoodsListBarcodeItem
     */
    businessPlatformName?: string;
}

/**
 * Check if a given object implements the StockGoodsListBarcodeItem interface.
 */
export function instanceOfStockGoodsListBarcodeItem(value: object): value is StockGoodsListBarcodeItem {
    return true;
}

export function StockGoodsListBarcodeItemFromJSON(json: any): StockGoodsListBarcodeItem {
    return StockGoodsListBarcodeItemFromJSONTyped(json, false);
}

export function StockGoodsListBarcodeItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockGoodsListBarcodeItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProductName': json['marketProductName'] == null ? undefined : json['marketProductName'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
        'businessPlatformName': json['businessPlatformName'] == null ? undefined : json['businessPlatformName'],
    };
}

export function StockGoodsListBarcodeItemToJSON(json: any): StockGoodsListBarcodeItem {
    return StockGoodsListBarcodeItemToJSONTyped(json, false);
}

export function StockGoodsListBarcodeItemToJSONTyped(value?: StockGoodsListBarcodeItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'marketBarcode': value['marketBarcode'],
        'marketProductName': value['marketProductName'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'businessPlatformId': value['businessPlatformId'],
        'businessPlatformName': value['businessPlatformName'],
    };
}

